import { gs } from '../helpers/settings';

/**
 * GeewenLogo.jsx —— 品牌标记
 *
 * 后台「品牌信息」里填了 Logo 图片 ⇒ 用图片; 没填 ⇒ 用内置的云雀剪影 SVG。
 *
 * ⚠️ SVG 渐变的 id 必须**每个实例唯一** (id 在整个 document 里唯一, 重名会让浏览器
 *    取到第一个定义) ⇒ 用模块级计数器在 oninit 时分配, 避免重渲染时 id 变化。
 */
let seq = 0;
export default class GeewenLogo {
  oninit() {
    this.gradientId = 'gsMarkGradient' + ++seq;
  }
  view() {
    const url = gs('geewen_logo_url', '');
    if (url) {
      return m("span", {
        class: "GS-mark GS-mark--image",
        "aria-hidden": "true"
      }, m("img", {
        class: "GS-mark-img",
        src: url,
        alt: ""
      }));
    }
    return m("span", {
      class: "GS-mark",
      "aria-hidden": "true"
    }, m("svg", {
      viewBox: "0 0 32 32",
      class: "GS-mark-svg",
      focusable: "false"
    }, m("defs", null, m("linearGradient", {
      id: this.gradientId,
      x1: "0",
      y1: "0",
      x2: "1",
      y2: "1"
    }, m("stop", {
      offset: "0",
      "stop-color": "#2D7BE5"
    }), m("stop", {
      offset: "1",
      "stop-color": "#238c59"
    }))), m("rect", {
      width: "32",
      height: "32",
      rx: "9",
      fill: `url(#${this.gradientId})`
    }), m("path", {
      d: "M5.5 23.5c1.6-6.8 6.1-11.2 12.6-12.9 2.9-.8 5.8-.9 8.4-.4-3 1.3-5.3 3.2-6.9 5.7-1.7 2.7-2.5 5.6-2.6 8.6-3.4-2.6-7.3-2.7-11.5-1z",
      fill: "#fff"
    })));
  }
}
flarum.reg.add('ziiven-geewen-site', 'forum/components/GeewenLogo', GeewenLogo);